import React, { useEffect } from "react";
import { Router } from "react-router";
import "./App.scss";
import "react-virtualized/styles.css";
import { Provider, observer } from "mobx-react";
import { history } from "library/core/utility";
import { IntlProvider } from "react-intl";
import { CssBaseline } from "@material-ui/core";
import AppRoutes from "core/stores/route/AppRoutes";
import QAWidget from "./containers/_layout/_components/qa-widget";
import { services, stores } from "./core/stores";
import Snackbar from "library/components/snackbar";
import { languageStore } from "library/core/stores/language/LanguageStore";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import config from "core/config";
import StorybookApp from "./library/src/App";
import CookieStorage from "library/core/utility/cookie-storage";
import LocalStorage from "library/core/utility/local-storage";

type AppProps = {};

const App: React.FunctionComponent<AppProps> = () => {
  const { googleCaptchaSiteKeyV3 } = config!;

  useEffect(() => {
    LocalStorage.clear();
  }, []);

  if (window.location.href.includes("?storybookEnabled=true")) {
    CookieStorage.set("storybookEnabled", "true");
  } else {
    CookieStorage.remove("storybookEnabled");
  }

  if (CookieStorage.get("storybookEnabled")) {
    return <StorybookApp />;
  }

  const activeLocale = languageStore.language;
  const fallbackMessages = languageStore.getMessages("en-US");
  const activeMessages = languageStore.getMessages(activeLocale);
  const mergedMessages = { ...fallbackMessages, ...activeMessages };

  return (
    <Provider {...services} {...stores}>
      <Router history={history}>
        <GoogleReCaptchaProvider reCaptchaKey={googleCaptchaSiteKeyV3}>
          <IntlProvider
            locale={activeLocale}
            defaultLocale='en-US'
            messages={mergedMessages}
            onError={err => {
              if (typeof err === "string" && err.includes("Missing message"))
                return;
              // eslint-disable-next-line no-console
              console.error(err);
            }}>
            <CssBaseline />
            <Snackbar />
            <AppRoutes />
            <QAWidget />
          </IntlProvider>
        </GoogleReCaptchaProvider>
      </Router>
    </Provider>
  );
};

export default observer(App);
